<div class="visual-builder-container">
	<div class="visual-builder-layout" cdkDropListGroup>
		<!-- Left Panel: Field Palette -->
		<div class="field-palette-panel">
			<nx-ahs-field-palette></nx-ahs-field-palette>
		</div>

		<!-- Center Panel: Builder Canvas -->
		<div class="builder-canvas-panel">
			<nx-ahs-builder-canvas
				[fields]="fields"
				[selectedFieldPath]="selectedFieldPath"
				(fieldSelected)="onFieldSelected($event)"
				(fieldUpdated)="onFieldUpdatedFromCanvas($event)"
				(fieldDropped)="onFieldDropped($event)"
				(fieldsChanged)="onCanvasFieldsChanged()"
			>
			</nx-ahs-builder-canvas>
		</div>

		<!-- Right Panel: Live Preview -->
		<div class="right-panel">
			<!-- Live Preview Section -->
			<div class="live-preview-section">
				<div class="preview-header">
					<h3 class="preview-title">
						<mat-icon>visibility</mat-icon>
						<span>Live Preview</span>
					</h3>
					<button mat-icon-button (click)="togglePreview()" matTooltip="Open full preview with testing">
						<mat-icon>fullscreen</mat-icon>
					</button>
				</div>
				<div class="preview-content">
					<div class="preview-form-wrapper" *ngIf="fields.length > 0">
						<lib-formly-collector
							[fields]="fields"
							[model]="livePreviewModel"
							[options]="previewOptions"
							[scriptId]="scriptId"
							[isFromBuilder]="true"
						>
						</lib-formly-collector>
					</div>
					<div class="preview-empty" *ngIf="fields.length === 0">
						<mat-icon>preview</mat-icon>
						<p>Add fields to see preview</p>
					</div>
				</div>
			</div>
		</div>

		<!-- Preview Panel (Overlay) -->
		<div class="preview-overlay" *ngIf="showPreview" (click)="closePreview()">
			<div class="preview-dialog" (click)="$event.stopPropagation()">
				<div class="preview-header">
					<h3 class="preview-title">
						<mat-icon>visibility</mat-icon>
						<span>Live Preview</span>
					</h3>
					<div class="preview-actions">
						<button
							mat-icon-button
							(click)="toggleValidationErrors()"
							[color]="showValidationErrors ? 'warn' : ''"
							[matTooltip]="showValidationErrors ? 'Hide validation errors' : 'Show validation errors'"
						>
							<mat-icon>{{ showValidationErrors ? 'error' : 'error_outline' }}</mat-icon>
						</button>
						<button mat-icon-button (click)="resetPreview()" matTooltip="Reset Form">
							<mat-icon>refresh</mat-icon>
						</button>
						<button mat-icon-button (click)="closePreview()" matTooltip="Close">
							<mat-icon>close</mat-icon>
						</button>
					</div>
				</div>
				<div class="preview-body">
					<div class="preview-form-section">
						<div class="section-header">
							<mat-icon>description</mat-icon>
							<span>Form Preview</span>
						</div>
						<div class="preview-content">
							<lib-formly-collector
								#previewFormly
								[fields]="fields"
								[model]="previewModel"
								[options]="previewOptions"
								[scriptId]="scriptId"
								[isFromBuilder]="true"
								(modelChanged)="onPreviewModelChanged($event)"
							>
							</lib-formly-collector>
						</div>
					</div>
					<div class="preview-model-section">
						<div class="section-header">
							<mat-icon>data_object</mat-icon>
							<span>Model Data</span>
						</div>
						<div class="model-viewer">
							<pre class="model-json" [innerHTML]="highlightedModelJson"></pre>
						</div>

						<!-- Validation Summary -->
						<div class="validation-summary" *ngIf="showValidationErrors">
							<div class="section-header validation-header">
								<mat-icon>error</mat-icon>
								<span>Validation Errors</span>
								<span class="error-count" *ngIf="validationErrors.length > 0">{{
									validationErrors.length
								}}</span>
							</div>
							<div class="validation-content">
								<div class="validation-success" *ngIf="validationErrors.length === 0">
									<mat-icon>check_circle</mat-icon>
									<span>No validation errors</span>
								</div>
								<div class="validation-error-list" *ngIf="validationErrors.length > 0">
									<div class="validation-error-item" *ngFor="let error of validationErrors">
										<div class="error-field">
											<mat-icon>report_problem</mat-icon>
											<strong>{{ error.field }}</strong>
										</div>
										<ul class="error-messages">
											<li *ngFor="let msg of error.errors">{{ msg }}</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
